import { differenceInDays, eachMonthOfInterval, format } from 'date-fns';
import { useMemo } from 'react';
import { toLocalMidnight } from '@/common/utils/dateFormats';

export const TimelineMonthGridLines = ({
  from,
  to,
  dayWidth,
  leftOffset = 0,
  height,
}: {
  from: string;
  to: string;
  dayWidth: number;
  leftOffset?: number;
  height: number;
}) => {
  const monthBoundaries = useMemo(() => {
    const start = toLocalMidnight(from);
    const end = toLocalMidnight(to);
    if (!start || !end) return [];
    const months = eachMonthOfInterval({ start, end });
    return months
      .map((m) => ({
        key: format(m, 'yyyy-MM'),
        left: leftOffset + differenceInDays(m, start) * dayWidth,
      }))
      .filter(({ left }) => left > leftOffset);
  }, [from, to, dayWidth, leftOffset]);

  return (
    <>
      {monthBoundaries.map(({ key, left }) => (
        <div
          key={key}
          className="absolute top-0 w-px bg-bg-neutral-bold/20 pointer-events-none z-10"
          style={{ left, height }}
        />
      ))}
    </>
  );
};
